import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-track-shipping-label',
  templateUrl: './track-shipping-label.component.html',
  styleUrls: ['./track-shipping-label.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class TrackShippingLabelComponent implements OnInit {

  constructor(public parent: ManagementComponent, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.SearchTerm = value;
        this.SearchTracking();
      });
  }

  searchTermUpdate = new Subject<string>();
  loadingShipment:boolean;
  SearchTerm:string;

  ShippingResponsabilities:any[];
  ShippingServiceTypes:any[];
  ShippingWays:any[];
  ShippingCompanies:any[];
  WeightTypes:any[];
  ShippingDetails: {[k: string]: any} = {};

  SelectedShippingCompany:any;
  TrackEvents:any[];
  CurrentTracking:any;

  Courier:string;
  Tracking:string;
  IsAutoLink:boolean = false;

  ngOnInit(): void {
    this.GetShippingMasterData();
  }

  getParamValues() {
    this.route.queryParams.subscribe(params => {   
      
      if(params['Courier']){
        this.Courier = params['Courier'];
      }
        
      if(params['Tracking']){
        this.Tracking = params['Tracking'];
      }

    
    });

    if(this.Courier != null && this.Tracking != null){
      this.IsAutoLink = true;
      this.SearchTerm = this.Tracking;
      this.SearchTracking();
    }
  }

  InitializeSearch(){
    if(this.Trackings == null || this.Trackings?.length == 0){
      if(this.SearchTerm?.length > 2){
        this.SearchTracking();
      }
    } 
  }

  GetShippingMasterData(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage()
   };
 
  this.parent.loading = true;
 
  this.managementService.GetShippingMasterData(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
     this.ShippingResponsabilities = response["ShippingResponsabilities"];
     this.ShippingServiceTypes = response["ShippingServiceTypes"];
     this.ShippingWays = response["ShippingWays"];
     this.ShippingCompanies = response["ShippingCompanies"];
     this.WeightTypes = response["WeightTypes"];
     this.SelectShippingCompany(this.ShippingCompanies[1]);

     this.getParamValues();
    }
 
    this.parent.loading = false;
   });
   }

   SelectShippingCompany(s:any){
    this.ShippingCompanies.forEach(element => {
      if (element.ID === s.ID) {
        element.IsSelected = true;
      } else {
        element.IsSelected = false;
      }
    });

    this.SelectedShippingCompany = s;
   }

   TrackShippingLabel(){

    this.ShippingDetails.ShippingCompany = this.SelectedShippingCompany;
    this.ShippingDetails.TrackingLabel = this.SearchTerm;

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetails:this.ShippingDetails
   };
 
  this.loadingShipment = true;
 
  this.managementService.TrackShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
     this.ShowPrintButton = false;
    }
    else if(response["Status"] == 1){
      var details = response["ShippingDetails"];

      this.TrackEvents = details.TrackHistory;
      this.Trackings = [];
      this.ShowPrintButton = true;
    }
 
    this.loadingShipment = false;
   });
   }

   PrintShippingLabel(TrackingLabel:string){

    this.ShippingDetails.ShippingCompany = this.SelectedShippingCompany;
    this.ShippingDetails.TrackingLabel = this.SearchTerm;

    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     ShippingDetails:this.ShippingDetails
   };
 
  this.loadingShipment = true;
 
  this.managementService.PrintShippingLabel(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShippingDetails = response["ShippingDetails"];
      
      for(var i=0; i < this.ShippingDetails.Documents.length; i++){
          this.parent.printPage(this.ShippingDetails.Documents[i].Name , this.ShippingDetails.Documents[i].PDFStream, this.ShippingDetails.Documents[i].ID);
      }
    }
 
    this.loadingShipment = false;
   });
   }

   Trackings:any[];
   ShowPrintButton:boolean = false;

   SearchTracking(){
    var request = {
     User:this.parent.User,
     Language:this.parent.getLanguage(),
     SearchTerm:this.SearchTerm
   };
 
  this.loadingShipment = true;
 
  this.managementService.SearchTracking(request).subscribe(response => {
 
    if(response["Status"] != 1){
     this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Trackings = response["Trackings"];
      this.CurrentTracking = {};
      this.TrackEvents = [];
      this.ShowPrintButton = false;

      if(this.Trackings?.length == 1){
        this.SelectTracking(this.Trackings[0]);
      }
      else if(this.IsAutoLink = true){
        this.ProofIfAllTrackingsAreTheSame();
      }
      else{
        this.loadingShipment = false;
      }
    }
 
   });
   }

   ProofIfAllTrackingsAreTheSame(){
      var allTheSame = true;

      for(var i=0; i < this.Trackings.length - 1; i++){
        if(this.Trackings[i].TrackingLabel != this.Trackings[i + 1].TrackingLabel){
          allTheSame = false;
          break;
        }
      }

      if(allTheSame){
        this.SelectTracking(this.Trackings[0]);
      }
   }

   SelectTracking(tracking:any){
    this.CurrentTracking = JSON.parse(JSON.stringify(tracking));
    this.SearchTerm = JSON.parse(JSON.stringify(tracking?.TrackingLabel));
    this.SelectShippingCompany(JSON.parse(JSON.stringify(tracking.ShippingCompany)));
    this.ShippingDetails.ID = tracking.ShippingDetailsID;
    this.ShippingDetails.ShippingDirection = tracking.ShippingDirection;
    this.Trackings = [];
    this.TrackShippingLabel();
   }

   CopyLabel(){
    const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['/management/new/shipment'], { queryParams: { copy: true, shipment: this.ShippingDetails?.ID, direction: this.CurrentTracking.ShippingDirection.ID } }));
    window.open(nextUrl, '_blank');
   }

}
